import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, flatMap, map, mergeMap, of } from 'rxjs';
import { RbacService } from '../../rbac/rbac.service';
import { FEATURES } from 'src/app/common/constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class TabAccessGuard {

  constructor(
    private readonly rbacService: RbacService,
    private readonly router: Router
  ) {}

  canActivate(
    action: string
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.rbacService.getAllFeatures().pipe(mergeMap(res=> {
        if(!res || !res.length){
          this.router.navigate(['unauthorized']);
          return of(false);
        }
        let menuFeat;
        res.forEach(val => {
          if(val.featureName.toLowerCase() === FEATURES.menu.toLowerCase()) {
            menuFeat = val;
          }
        })
        return this.rbacService.getPermissionsForFeature(menuFeat._id).pipe(map(response => {
          const allowedActions = response?.actions?.map(action => {
            return action.toLowerCase();
          })
          if(allowedActions?.includes(action.toLowerCase())) {
            return true;
          } else {
            this.router.navigate(['unauthorized']);
            return false;
          }
        }));
      }));
  }
  
}
